import spacing from '../spacing/spacing';
import colors from '../colors/colors';
import typography from '../typography/typography';

const button = {
  borderRadius: '4px',
  textAlign: 'center',
  letterSpacing: '0px',
  height: '48px',
  minWidth: '161px',
  cursor: 'pointer',
  paddingLeft: spacing.standard,
  paddingRight: spacing.standard,
  textTransform: 'unset',
  font: typography.p.font,
  fontWeight: 'bold',
  border: '1px solid transparent',
};

const font = {
  standard: {
    ...typography.buttons.standard,
  },
  'standard-bold': {
    ...typography.buttons['standard-bold'],
  },
};

const buttons = {
  default: button,
  size: font,
  primary: {
    ...button,
    background: colors.white,
    border: `1px solid ${colors.secondary}`,
    color: colors.black,
    '&:hover': {
      background: colors.white,
      border: `1px solid ${colors.secondary}`,
      color: colors.black,
    },
  },
  secondary: {
    ...button,
    background: colors.secondary,
    border: `1px solid ${colors.secondary}`,
    color: colors.white,
    '&:hover': {
      background: colors.secondary,
      border: `1px solid ${colors.secondary}`,
    },
  },
  main: {
    ...button,
    background: colors.main,
    border: `1px solid ${colors.main}`,
    color: colors.white,
    '&:hover': {
      background: colors.main,
      border: `1px solid ${colors.main}`,
    },
  },
  cancel: {
    ...button,
    background: colors.black,
    border: `1px solid ${colors.black}`,
    color: colors.white,
    '&:hover': {
      background: colors.black,
      border: `1px solid ${colors.black}`,
    },
  },
  warningRemove: {
    ...button,
    background: colors.warning,
    border: `1px solid ${colors.warning}`,
    color: colors.white,
    '&:hover': {
      background: colors.warning,
      border: `1px solid ${colors.warning}`,
    },
    '&:disabled': {
      background: '#e39d98',
      border: '1px solid #e39d98',
      color: colors.white,
    },
  },
  toolbarButton: {
    ...button,
    background: colors.white,

    border: 'none',
    color: colors.black,
    '&:hover': {
      border: 'none',
      background: colors.white,
    },
  },
  'secondary-inverse': {
    ...button,
    background: colors.white,
    border: `1px solid ${colors.secondary}`,
    color: colors.secondary,
    '&:hover': {
      opacity: [0.5, 0.8, 0.7],
      border: `1px solid ${colors.secondary}`,
    },
  },
  naked: {
    background: 0,
    border: 0,
    minWidth: 'unset',
    '&:hover': {
      background: 0,
      border: 0,
    },
  },
  close: {},
  disabled: {
    cursor: 'not-allowed',
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'not-allowed',
  },
};

export default buttons;
